import axios from 'axios';

// Variables para manejar el refresh de tokens
let isRefreshing = false;
let queue = [];

const redirectToLogin = () => {
  try {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('currentUser');
  } catch (e) {
    console.error('Error al limpiar la sesión:', e);
  }

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};


const http = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://192.168.1.10:3001/api',
  withCredentials: true, 
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Interceptor de Request: Agregar token Bearer automáticamente
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function attachNormalizedError(error) {
  try {
    const res = error?.response;
    const data = res?.data;
    error.__normalized = {
      status: res?.status,
      code: data?.error?.code ?? data?.code,
      message: data?.error?.message ?? data?.message ?? error.message,
      details: data?.error?.details ?? data?.details,
    };
  } catch {
    error.__normalized = { message: error?.message || 'Error' };
  }
  return error;
}

// Interceptor de Response: Manejar errores globalmente
http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config || {};
    const status = error?.response?.status;
    const isAuthPath = (p) => p?.includes('/auth/login') || p?.includes('/auth/refresh');
    const isPublicPath = (config) =>
      config?.skipAuthRedirect ||
      config?.url?.includes('/clients/account-deletion/confirm');

    if (
      status === 401 &&
      !original._retry &&
      !isAuthPath(original.url) &&
      !isPublicPath(original)
    ) {
      original._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const { data } = await http.post('/auth/refresh');
          localStorage.setItem('accessToken', data.accessToken);
          queue.forEach((cb) => cb(data.accessToken));
          queue = [];
        } catch (e) {
          // limpiar sesión
          redirectToLogin();
          queue = [];
          isRefreshing = false;

          attachNormalizedError(error);
          return Promise.reject(error);
        }
        isRefreshing = false;
      }

      return new Promise((resolve) => {
        queue.push((newToken) => {
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${newToken}`;
          resolve(http(original));
        });
      });
    }

    if (status === 401 && !isAuthPath(original.url) && !isPublicPath(original)) {
      redirectToLogin();
    }

    attachNormalizedError(error);
    return Promise.reject(error);
  }
);

export default http;

